/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';

interface Props {
    dialogTitle: any;
    dialogContent: any;
    open: boolean;
    handleClose: Function;
    handleOk: Function;
    noCancelButton?: boolean;
}

class AlertDialog extends React.Component<Props> {

    handleClose = () => {
        this.props.handleClose();
    };

    handleOk = () => {
        this.props.handleOk();
        this.handleClose();
    };
    render() {
        return (
            <div>
                <Dialog
                    open={this.props.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{this.props.dialogTitle}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {this.props.dialogContent}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        {!this.props.noCancelButton &&
                            <Button onClick={this.handleClose} color="primary">
                                Cancel
                            </Button>
                        }
                        <Button onClick={this.handleOk} color="primary" autoFocus>
                            Ok
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default AlertDialog;
